import { render, staticRenderFns } from "./JournalFileModal.vue?vue&type=template&id=19ecc9b4&scoped=true&"
import script from "./JournalFileModal.vue?vue&type=script&lang=ts&"
export * from "./JournalFileModal.vue?vue&type=script&lang=ts&"
import style0 from "./JournalFileModal.vue?vue&type=style&index=0&id=19ecc9b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ecc9b4",
  null
  
)

export default component.exports